import React, { useState } from 'react'
import {
    Box, Switch, Button, Collapse, IconButton, Paper, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Typography, MenuItem, FormControl,
    Select, SelectChangeEvent, ListItemText, Checkbox, OutlinedInput, TextField,
    InputAdornment, FormHelperText, Snackbar, Alert, Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    List,
    ListItem
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';

const BlackWhiteSwitches = styled(Switch)(() => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#000',
    '& + .MuiSwitch-track': {
      backgroundColor: '#000',
    },
  },
  '& .MuiSwitch-switchBase': {
    color: '#ccc',
  },
  '& .MuiSwitch-track': {
    backgroundColor: '#ccc',
  },
}));

const SuperScreen = () => {
    const [tripType, setTripType] = React.useState('');
    const [isActive, setIsActive] = useState<boolean>(true);
    const [toggleChanged, setToggleChanged] = useState<boolean>(false);
    const handleTripChange = (event: SelectChangeEvent) => {
        setTripType(event.target.value);
    };
    const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsActive(event.target.checked);
    };
    const [fromDate, setFromDate] = useState<dayjs.Dayjs | null>(null);
    const [toDate, setToDate] = useState<dayjs.Dayjs | null>(null);
    
    const [fromOpen, setFromOpen] = useState(false);
    const [toOpen, setToOpen] = useState(false);
    
    const handleDateChange = (newValue: dayjs.Dayjs | null) => {
        setToDate(newValue);
        setToOpen(false); // Close the calendar after selecting a date
    };
  return (
    <>
      <Box className="headingBtnWrap" sx={{marginBottom: "20px"}}>
        <Typography variant="h1">Super Screen</Typography>
    </Box>

    <Accordion>
        <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
        >
            <Typography component="span">Super Screen Information</Typography>
        </AccordionSummary>
        <AccordionDetails>
            <Box className="feeModalForm">
                <Box className="segmentCard superCard">
                    <Box className="feeInputFieldWrap">
                        <div className="form-control inputFieldWrap">
                            <label>Trip Type</label>
                            <FormControl sx={{ minWidth: 315 }} className="commondropdownWrap">
                                  <Select
                                    className="commondropdown"
                                    id="supplier-select"
                                    value={tripType}
                                    onChange={handleTripChange}
                                    displayEmpty
                                    renderValue={(selected) => {
                                      if (!selected) {
                                        return <span style={{ color: "#888" }}>Select Trip Type</span>;
                                      }
                                      return selected;
                                    }}
                                  >
                                    <MenuItem value="">
                                      Select Trip Type
                                    </MenuItem>
                                    <MenuItem value="OneWay">One Way</MenuItem>
                                    <MenuItem value="RoundTrip">Round Trip</MenuItem>
                                    <MenuItem value="MultiCity">Multicity</MenuItem>
                                  </Select>
                                </FormControl>
                        </div>
                        <div className="form-control inputFieldWrap">
                            <label>Departure City / Airport</label>
                            <input type="text" className="inputField"/>
                        </div>
                        <div className="form-control inputFieldWrap">
                            <label>Arrival City / Airport</label>
                            <input type="text" className="inputField"/>
                        </div>
                        <div className="form-control inputFieldWrap">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <label>Departure Date</label>
                            <div onClick={() => setFromOpen(true)}>
                                <DatePicker
                                    open={fromOpen}
                                    onOpen={() => setFromOpen(true)}
                                    onClose={() => setFromOpen(false)}
                                    value={fromDate}
                                    onChange={(newValue) => setFromDate(newValue)}
                                    slotProps={{ textField: { fullWidth: true } }}
                                    className='datePickerWrap'
                                />
                                </div>
                            </LocalizationProvider>
                        </div>
                        <div className="form-control inputFieldWrap">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <label>Return Date</label>
                            <div onClick={() => setToOpen(true)}>
                                <DatePicker
                                    open={toOpen}
                                    // onOpen={() => setToOpen(true)}
                                    onClose={() => setToOpen(false)}
                                    value={toDate}
                                    onChange={handleDateChange}
                                    slotProps={{ textField: { fullWidth: true } }}
                                    className='datePickerWrap'
                                />
                                </div>
                            </LocalizationProvider>
                        </div>
                        <div className="form-control inputFieldWrap">
                            <label>Flight Number</label>
                            <input type="text" className="inputField"/>
                        </div>
                        <div className="form-control inputFieldWrap">
                            <label>Source (GDS/API)</label>
                            <input type="text" className="inputField"/>
                        </div>
                        <div className="form-control inputFieldWrap">
                            <label>Operating Airline</label>
                            <input type="text" className="inputField"/>
                        </div>
                        <div className="form-control inputFieldWrap">
                            <label>Marketing Airline</label>
                            <input type="text" className="inputField"/>
                        </div>
                        <div className="form-control inputFieldWrap">
                            <label>Supplier</label>
                            <input type="text" className="inputField"/>
                        </div>
                        <div className="form-control inputFieldWrap">
                            <label>Office ID</label>
                            <input type="text" className="inputField"/>
                        </div>
                        <div className="form-control inputFieldWrap">
                            <label>Discount</label>
                            <input type="text" className="inputField"/>
                        </div>
                        <div className="form-control inputFieldWrap">
                            <label>Markup</label>
                            <input type="text" className="inputField"/>
                        </div>
                        <div className="form-control inputFieldWrap">
                            <label>Active</label>
                            <Box display="flex" alignItems="center" gap={2} >
                            <BlackWhiteSwitches checked={isActive} onChange={handleToggle} />
                            </Box>
                        </div>
                    </Box>
                    <div className='searchInputFilterBox saveBtn'>
                        <Button
                            variant="contained"
                            className="searchBtn"
                            color="primary"
                            type="button"
                        >
                            Save
                        </Button>
                    </div>
                </Box>
            </Box>
        </AccordionDetails>
    </Accordion>
    </>
  )
}

export default SuperScreen
